module.exports = __webpack_public_path__ + "img/market-support.893026bc.jpg";